module.exports = __webpack_public_path__ + "3024e4eda38c4e04d52c5240684a9c73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icon-font/iconFont.svg
// module id = 1094
// module chunks = 0